var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#364356",
    d: "m10 12.24 6.293-6.44a.984.984 0 0 1 1.414 0c.39.399.39 1.047 0 1.447l-6.646 6.803c-.586.6-1.536.6-2.122 0L2.293 7.247a1.04 1.04 0 0 1 0-1.448.984.984 0 0 1 1.414 0z"
  })));
};
export default SvgIconArrowDown;